// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","523":"cb1608f2"}[chunkId] || chunkId) + "-" + {"230":"c77b43f1a270df3d7eba","256":"cc3587aedb21f470a7c9","523":"c9cafc21c4c6a213abfd","589":"28c97c28a2846370d09a"}[chunkId] + ".js";
};